module.exports = __webpack_public_path__ + "media/images/icons/close-icon-8e1eeff3e96c5b2724f9809fa390f81b.svg";